'use strict';

class ContactoController {
  constructor($log, $scope, DataService, Message, Util, Loading) {
    'ngInject';
    this.$log = $log;
    this.$scope = $scope;
    this.DataService = DataService;
    this.Message = Message;
    this.Util = Util;
    this.Loading = Loading;
    this.listaContactos = [];
    this.dataContacto = {};
    this.dataContacto.telefonos = [];
    this.conf = {};
    this.insertaNuevo = false;
  }
  $onInit() {
    this.conf = this.data;
    this.contactosLoad();
  }
  contactosLoad() {
    this.DataService.get(`certificaciones/${this.idCertificacion}/contactos`)
    .then(response => {
      if (angular.isArray(response) && response.length > 0) {
        this.listaContactos = response;
        this.$log.log(this.listaContactos);
      }
    })
  }
  contactoAdd() {
    this.insertaNuevo = true;
  }
  save(contacto_form) {
    if (contacto_form.$valid) {
      let contacto;
      contacto = angular.copy(this.dataContacto);
      contacto.telefonos = this.dataContacto.telefonos.join('|');
      this.$log.log("==================================================================");
      this.$log.log(contacto);
      this.DataService.save(`certificaciones/${this.idCertificacion}/contactos/`, contacto)
      .then(response => {
        this.$log.log("====================================responsillo==============================");
        this.$log.log(response);
        this.dataContacto.nombre_completo = null;
        this.dataContacto.telefonos = [];
        this.contactosLoad();
        this.Util.setTouchedForm(contacto_form, false);
        // this.insertaNuevo = false;
        this.Message.success();
      })
      .catch(error => {
        this.$log.log(error);
        this.Message.error('Ocurrió un error intentando guardar el contacto.');
      });
    } else {
      this.Util.setTouchedForm(contacto_form);
    }
  }
  contactoDel(index, item) {
    this.DataService.delete(`certificaciones/${this.idCertificacion}/contactos/${item.id_contacto}`)
    .then(response => {
      this.$log.log(response);
      this.insertaNuevo = false;
      this.listaContactos.splice(index, 1);
      this.Message.success();
    })
    .catch(error => {
      this.$log.log(error);
      this.Message.error('Ocurrió un error intentando eliminar el contacto.');
    });
  }
  cancel() {
    this.$uibModalInstance.close();
    // this.$uibModalInstance.dismiss('cancel');
  }
  beforeAddTel(text) {
    var array = this.dataContacto.telefonos;
    if (array.length >= 5) {
      this.Message.warning('Solo puede añadir 5 teléfonos como máximo.');
      return null;
    }
    if (text.length > 15) {
      this.Message.warning("El número telefónico '" + text + "' no debe superar los 15 dígitos");
    } else if (text.length < 5) {
      this.Message.warning("El número telefónico '" + text + "' no debe ser inferior a los 5 caracteres");
    } else if (!/^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d?)\)?)?[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?){0,})(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i.test(text)) {
      this.Message.warning("Introduzca un número de teléfono válido: " + text);
    } else {
      return text;
    }
    return null;
  }
}

export default ContactoController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/contacto/contacto.controller.js